import Color from 'color';
import { useMemo } from 'react';
import { ROOT_MEDIA } from 'shared-base';

export function useEditorBackground(params: IHolodeckState) {
  const {
    backgroundColor = '#0e2158',
    backgroundIntensity = 1,
    backdropEnabled,
    backdropId,
  } = params;

  const style: React.CSSProperties = useMemo(() => {
    const intensity = Math.min(Math.max(backgroundIntensity, 0), 1); // Clamp between 0 and 1

    // Adjust the secondary color intensity using color package
    const secondaryColor = Color(backgroundColor)
      .darken(1 - intensity)
      .hex();

    const output: React.CSSProperties = {};

    if (!params.backdropEnabled) {
      output.background = `radial-gradient(circle, ${backgroundColor}, ${secondaryColor})`;
    } else {
      output.backgroundImage = `url(${ROOT_MEDIA}/B-${lz(backdropId ?? '')}.jpg)`;
    }

    return output;
  }, [backgroundColor, backgroundIntensity, backdropEnabled, backdropId]);

  return style;
}

const lz = (number: string) => {
  return String(number).padStart(3, '0');
};
